import React from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import {
	Login,
	Clients,
	Recovery,
	ViewItem,
	Download,
	AllProducts,
	UZ_Download,
	DollarCourse,
	RecoveryChart,
	CreateProducts,
	IStyleDownload,
	ViewRecoveryItem,
	SettingsPage,
	OutgoingPaymentPage,
	Dashboard,
	PurchasesPage,
	ConstantConsumptionPage,
	PaySupplierPage,
	AllProductsPartner,
	CreateProductsPartner,
	CashPaymentPage,
	InstallmentPlanPage,
	CreateProductsInstallmentPage,
	CreateProductsCashPaymentPage,
	SMSPage,
	Task,
	Sales,
	InventoryTransfers,
	CreateInventoryTransfers,
	IcloudPage,
	Spisaniya,
	AddSpisaniya,
	ForgivvedPurchases,
	AddForgivvedPurchases,
	CreateJournalEntries,
	JournalEntries,
	CreateGetMoneyFrom,
	GetMoneyFrom,
	Root,
	Complaints,
	Ledger,
	CashbackSummary,
	NasiyaSettings,
} from '../screens'
import CreatePurchasesPage from '../screens/CreatePurchases'
import Convert from '../screens/Convert'
import PurchaseInvoiceView from '../screens/PurchaseInvoiceView'
import WhsReports from '../screens/Reports'
import RemovedPhones from '../screens/RemovedPhones'
import AddProductPage from '../screens/AddProduct'
import UndiruvchiDashboard from '../screens/UndiruvchiDashboard'
import BlackList from '../screens/BlackList'
import CreateDraftJournalEntries from '../screens/JournalEntries/CreateDraft'
import SentJournalEntries from '../screens/JournalEntries/SentJournalEntries'
import ReceivedJournalEntries from '../screens/JournalEntries/ReceivedJournalEntries'
import InfoAboutCash from '../screens/InfoAboutCash'
import BlackListClients from '../screens/BlackList/BlackListClients'
import DemoDashboard from '../screens/DemoInvoices/Dashboard'
import DemoInvoices from '../screens/DemoInvoices'
import DemoInvoiceCard from '../screens/DemoInvoices/InvoiceCard'
import DemoCreateInvoice from '../screens/DemoInvoices/CreateInvoice'

function App() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path="/login" element={<Login />} />
				<Route path="/recovery" element={<Recovery />} />
				<Route path="/clients" element={<Clients />} />
				<Route path="/download" element={<Download />} />
				<Route path="/viewItem" element={<ViewItem />} />
				<Route path="/uz_download" element={<UZ_Download />} />
				<Route path="/allProducts" element={<AllProducts />} />
				<Route path="/dollarCourse" element={<DollarCourse />} />
				<Route path="/ru_download" element={<IStyleDownload />} />
				<Route path="/recoveryChart" element={<RecoveryChart />} />
				<Route path="/createProducts" element={<CreateProducts />} />
				<Route path="/create-get-money" element={<CreateGetMoneyFrom />} />
				<Route path="/get-money" element={<GetMoneyFrom />} />
				<Route path="/viewRecoveryItem" element={<ViewRecoveryItem />} />
				<Route path="/outgoing-payment" element={<OutgoingPaymentPage />} />
				{/* <Route path="/cash-flow-report" element={<CashFlowReportPage />} /> */}
				{/* <Route path="/dds-report" element={<DDSReportPage />} /> */}
				<Route path="/task" element={<Task />} />
				<Route path="/root" element={<Root />} />
				<Route path="/settings" element={<SettingsPage />} />
				<Route path="/dashboard" element={<Dashboard />} />
				<Route path="/purchases" element={<PurchasesPage />} />
				<Route path="/sales" element={<Sales />} />
				<Route path="/reports" element={<WhsReports />} />
				<Route path="/add-product" element={<AddProductPage />} />
				<Route path="/removedPhones" element={<RemovedPhones />} />
				<Route path="/icloud" element={<IcloudPage />} />
				<Route path="/inventory-transfer" element={<InventoryTransfers />} />
				<Route path="/spisaniya" element={<Spisaniya />} />
				<Route path="/add-spisaniya" element={<AddSpisaniya />} />
				<Route path="/forgivved" element={<ForgivvedPurchases />} />
				<Route
					path="/add-forgivved-purchases"
					element={<AddForgivvedPurchases />}
				/>
				<Route
					path="/create-journal-entries"
					element={<CreateJournalEntries />}
				/>
				<Route
					path="/create-draft-journal-entries"
					element={<CreateDraftJournalEntries />}
				/>
				<Route
					path="/sent-draft-journal-entries"
					element={<SentJournalEntries />}
				/>
				<Route
					path="/received-draft-journal-entries"
					element={<ReceivedJournalEntries />}
				/>
				<Route path="/journal-entries" element={<JournalEntries />} />

				<Route path="/create-purchases" element={<CreatePurchasesPage />} />
				<Route
					path="/create-inventory-transfers"
					element={<CreateInventoryTransfers />}
				/>
				<Route
					path="/constant-consumption"
					element={<ConstantConsumptionPage />}
				/>
				<Route path="/all-products-partner" element={<AllProductsPartner />} />
				<Route
					path="/create-products-partner"
					element={<CreateProductsPartner />}
				/>
				<Route path="/pay-supplier" element={<PaySupplierPage />} />
				<Route path="/cash-payment" element={<CashPaymentPage />} />
				<Route path="/installment-plan" element={<InstallmentPlanPage />} />
				<Route
					path="/createProducts-installment"
					element={<CreateProductsInstallmentPage />}
				/>
				<Route path="/convert" element={<Convert />} />
				<Route
					path="/createProducts-payment"
					element={<CreateProductsCashPaymentPage />}
				/>
				<Route path="/viewPartnerInvoice" element={<PurchaseInvoiceView />} />
				<Route path="/sms" element={<SMSPage />} />
				{/* <Route path="/logs" element={<Logs />} /> */}
				<Route path="/" element={<Navigate to={'/login'} />} />

				{/* <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */}
				{/* added new menu ReportOnCollectors */}
				{/* <Route path="/dunnersIndicator" element={<ReportOnCollectors />} /> */}

				{/* ========== added new menu Undiruvchi Dashboard ========== */}
				<Route path="/undiruvchi-dashboard" element={<UndiruvchiDashboard />} />
				<Route path="/black-list" element={<BlackList />} />
				<Route path="/black-list-clients" element={<BlackListClients />} />

				{/* ========== NEW MENUS ========== */}
				<Route path="/info-about-cash" element={<InfoAboutCash />} />
				<Route path="/complaints" element={<Complaints />} />
				<Route path="/ledger" element={<Ledger />} />
				<Route path="/cashback-summary" element={<CashbackSummary />} />
				<Route path="/nasiya-settings" element={<NasiyaSettings />} />

				{/* ========== DEMO (A/R Invoices topshiriq) — menuda emas, Layout headeridagi «Demo» tugmasidan ochiladi ========== */}
				<Route path="/demo" element={<DemoDashboard />} />
				<Route path="/demo/invoices" element={<DemoInvoices />} />
				<Route path="/demo/invoices/new" element={<DemoCreateInvoice />} />
				<Route
					path="/demo/invoices/:docEntry"
					element={<DemoInvoiceCard />}
				/>
			</Routes>
		</BrowserRouter>
	)
}

export default App
